import React from 'react';
import { Link } from 'react-router-dom';
import swal from 'sweetalert';
import axiosInstance from '../../../../services/AxiosInstance';

const AllCandidates = ({ data, delIds, setDelIds, header, pagination, getData, view }) => {

    const handleSelect = (e, id, name) => {
        if (e.target.checked) {
            setDelIds(delIds => [...delIds, id]);
        } else {
            setDelIds(delIds => delIds.filter(item => item !== id));
        }
        if (name) {
            if (e.target.checked) {
                let ids = [];
                for (let index = 0; index < data?.length; index++) {
                    ids.push(data?.[index]?.id);
                }
                setDelIds(ids);
            } else setDelIds([]);
        }
    }

    const handleApprove = (id) => {
        axiosInstance(`user/${id}/`, { method: "PATCH", data: { "joc_approve_status": "a" } })
            .then(res => {
                if (res.status === 200) {
                    getData();
                    swal("", "Approved Successfully", "success", { button: "Ok!", })
                }
            }).catch(err => swal("", Object.values(err.response.data), "error", { button: "Ok!", }))
    }

    const handleDeny = (id) => {
        axiosInstance(`user/${id}/`, { method: "PATCH", data: { "joc_approve_status": "d" } })
            .then(res => {
                if (res.status === 200) {
                    getData();
                    swal("", "Denied Successfully", "success", { button: "Ok!", })
                }
            }).catch(err => swal("", Object.values(err.response.data), "error", { button: "Ok!", }))
    }

    const handleRedList = (id, value) => {
        axiosInstance(`user/${id}/`, { method: 'PATCH', data: { red_listed: value } }).then(() => {
            getData();
            swal("", `${value ? "Red Listed Successfully" : "Removed from Red List Successfully"}`, "success", { button: "Ok!", })
        }).catch(err => swal("", Object.values(err.response.data), "error", { button: "Ok!", }))
    }

    const handleResetPassword = (email, username) => {
        swal({
            title: "Are you sure?",
            text: "Are you sure that you want to set the username as password for this user?",
            icon: "warning",
            dangerMode: false,
        })
            .then(willDelete => {
                if (willDelete) {
                    axiosInstance('reset_password/', { method: 'PUT', data: { email: email, password: username } })
                        .then(res => {
                            if (res.status === 200) {
                                swal("", "Password Reset Successfully", "success", { button: "Ok!", })
                            }
                        }).catch(err => swal("", Object.values(err.response.data), "error", { button: "Ok!", }))
                }
            });
    }

    return (
        <div className="table-resposive template-table">
            <table className="table-job-bx cv-manager company-manage-job">
                <thead>
                    <tr>
                        <th>
                            <input
                                type="checkbox"
                                id="vehicle1"
                                name="vehicle1"
                                value="Bike"
                                checked={data?.length > 0 && data?.length === delIds?.length}
                                onChange={(e) => handleSelect(e, 'all', 'all')}
                            />
                        </th>
                        <th className="feature">#</th>
                        {
                            header?.map(res => <th key={res}>{res}</th>)
                        }
                        <th className="feature text-center p-0">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        data?.map((res, i) => {
                            console.log('res: ', res);
                            var id = +`${pagination?.currentPage - 1}0`;
                            return (
                                <tr key={`${res.id}tr`}>
                                    <td>
                                        <input
                                            type="checkbox"
                                            name={`select${res?.id}`}
                                            checked={delIds?.includes(res?.id)}
                                            onChange={(e) => handleSelect(e, res.id)}
                                        />
                                    </td>
                                    <td className="feature" key={id + i + 1}>{id + i + 1}</td>
                                    <td>{res?.name}</td>
                                    <td>{res?.email}</td>
                                    <td>{res?.date_joined}</td>
                                    <td>{res?.joc_approve_status}</td>
                                    <td>
                                        <Link to={`${view}/${res?.role === 4 ? res?.id : res?.institution}`}>
                                            <i className="fa fa-eye" title="Click to view the profile" />
                                        </Link>
                                        {
                                            res?.joc_approve_status !== "Approved" &&
                                            <span onClick={() => handleApprove(res.id)} >
                                                <i className="fa fa-check" title='Click here to approve' style={{ cursor: "pointer" }} />
                                            </span>
                                        }
                                        {
                                            res?.joc_approve_status !== "Denied" &&
                                            <span onClick={() => handleDeny(res.id)} >
                                                <i className="fa fa-close" title="Click here to deny" style={{ cursor: "pointer" }} />
                                            </span>
                                        }
                                        {
                                            !(res?.red_listed) ?
                                                <span onClick={() => handleRedList(res.id, true)}>
                                                    <i className="fa fa-ban text-danger" title='Click here to mark user as red list' style={{ cursor: "pointer" }} />
                                                </span>
                                                :
                                                <span onClick={() => handleRedList(res.id, false)}>
                                                    <i className="fa fa-thumbs-up" title='Click here to unmark user as red list' style={{ cursor: "pointer" }} />
                                                </span>
                                        }
                                        <span onClick={() => handleResetPassword(res?.email, res?.username)} style={{ cursor: "pointer" }}><i class="fa fa-key" title="Click here to reset password" /></span>
                                    </td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    );
};

export default AllCandidates;